<div class="container-fluid p-0">
  <div class="authentication-main">
    <div class="row">
      <div class="col-md-12 p-0">
        <div class="auth-innerright">
          <div class="authentication-box">
            <div class="card mt-4">
              <div class="card-header bg-info">
                <div class="text-center"><img src="../../../assets/images/logo/logo-inniver-small.png" alt=""></div>
              </div>
              <div class="card-body">
                <div class="text-center">
                  <h4>LOGIN</h4>
                  <h6>Enter your Username and Password </h6>
                </div>
                <!-- <form class="theme-form"> -->
                  <form class="ngx-form" [formGroup]="loginForm" novalidate>
                    <div class="form-group">
                      <label class="control-label" for="userName">Username</label>
                      <input type="text" formControlName="userName" id="userName"  class="form-control" placeholder="Enter user name.." required (keyup)="onKey($event)">
                      <div *ngIf="loginForm.controls['userName'].invalid && (loginForm.controls['userName'].dirty || loginForm.controls['userName'].touched)"
                        class="alert">                        
                          User name is required.                       
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="control-label" for="f1-password">Password</label>
                      <input type="password" formControlName="password" class="form-control" autocomplete="off"
                        placeholder="Enter Password.." (keyup)="onKey($event)">
                      <div *ngIf="loginForm.controls['password'].invalid && (loginForm.controls['password'].dirty || loginForm.controls['password'].touched)"
                        class="alert">
                        <div *ngIf="loginForm.controls['password'].errors?.['required']">Password is required.</div>
                        <div *ngIf="loginForm.controls['password'].errors?.['minlength']">Password must be at least 8 characters</div>
                      </div>
                    </div>
                    <!-- <div class="checkbox p-0">
                      <input id="checkbox1" type="checkbox" disabled>
                      <label for="checkbox1">Remember me</label>
                    </div> -->
                    <div class="f1-buttons">
                      <button class="btn btn-pill btn-primary btn-submit" type="submit" [disabled]="!loginForm.valid"
                      (click)="onSubmit()">Submit</button>
                    </div>

                    <div class="form-group">
                      <div class="col-md-12" *ngIf="isLoginFailed">
                        <label class="control-label" for="f1-password">Oops...</label>
                        <div class="text-center alert alert-danger">something went wrong</div>
                      </div>
                    </div>
                  </form>


                  <!-- <div class="form-group form-row mt-3 mb-0">
                    <button class="btn btn-secondary btn-block" type="submit">Login With Auth0</button>
                  </div> -->
                  <!-- <div class="login-divider"></div>
                  <div class="social mt-3">
                    <div class="form-group btn-showcase d-flex">
                      <button class="btn social-btn btn-fb d-inline-block"> <i class="fa fa-facebook"></i></button>
                      <button class="btn social-btn btn-twitter d-inline-block"><i class="fa fa-google"></i></button>
                      <button class="btn social-btn btn-google d-inline-block"><i class="fa fa-twitter"></i></button>
                      <button class="btn social-btn btn-github d-inline-block"><i class="fa fa-github"></i></button>
                    </div>
                  </div> -->
                <!-- </form> -->
              </div>
            </div>
            <div class="text-center">Do not have an account? <a class="btn-link"
              href="authentication/register">Join us and register!</a></div>
            <div class="text-center">I'm having trouble signing in or <a class="btn-link"
              href="authentication/forgetpassword">forgot my password</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
